import React from "react"

interface SettingsCogIconProps {
  color?: string;
}

const SettingsCogIcon: React.FC<SettingsCogIconProps> = ({
  color = "currentColor",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 21H9.99999L9.44899 18.52C8.79324 18.2636 8.17999 17.9096 7.62999 17.47L5.20599 18.233L3.20599 14.769L5.07799 13.051C4.97323 12.3549 4.97323 11.6471 5.07799 10.951L3.20599 9.232L5.20599 5.768L7.62999 6.531C8.18024 6.09097 8.79384 5.73664 9.44999 5.48L9.99999 3H14L14.551 5.48C15.2067 5.73642 15.82 6.09041 16.37 6.53L18.794 5.767L20.794 9.231L18.922 10.949C19.0268 11.6451 19.0268 12.3529 18.922 13.049L20.794 14.767L18.794 18.231L16.37 17.468C15.8201 17.9083 15.2069 18.263 14.551 18.52L14 21Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  )
}

export default SettingsCogIcon
